import { useCallback } from 'react';
import { AnchoredSheet, AnchoredSheetTitleBar } from '@shared/components/AnchoredSheet';
import { MBView } from '@shared/components/MBView';
import { grid } from '@shared/styles';
import { API } from '@shared/types/api';
import { useIsDesktop } from '@shared/util/hooks';
import { SelectSubform } from './SelectSubform';

const FIXED_WIDTH = { width: grid(46) };

interface Props {
  blockLabel: string;
  anchorName: string;
  workflowTemplate?: API.WorkflowTemplateFragment;
  onClose: VoidFunction;
  onSelect: (subformWorkflowTemplate: API.WorkflowTemplateFragment) => void;
  navigateToAdd?: () => void;
}

export function SubformsSheet({
  blockLabel,
  anchorName,
  workflowTemplate,
  onClose,
  onSelect,
  navigateToAdd,
}: Props) {
  const isDesktop = useIsDesktop();
  const fixedWidth = isDesktop ? FIXED_WIDTH : null;

  const renderTitleBar = useCallback(() => {
    return <AnchoredSheetTitleBar title={blockLabel} rightIcon="exit" onRightIconPress={onClose} />;
  }, [onClose, blockLabel]);

  return (
    <AnchoredSheet
      anchorName={anchorName}
      style={{
        minWidth: fixedWidth?.width,
        minHeight: grid(36),
      }}
      onClose={onClose}
      renderTitleBar={!isDesktop ? renderTitleBar : undefined}
    >
      <MBView style={fixedWidth} fill>
        <SelectSubform
          workflowTemplate={workflowTemplate}
          onSelect={onSelect}
          navigateToAdd={navigateToAdd}
        />
      </MBView>
    </AnchoredSheet>
  );
}
